// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel--active[data-v-a5ca73ec] .v-expansion-panel-header{background-color:var(--v-warning-base);min-height:49px}.v-expansion-panels[data-v-a5ca73ec] .v-expansion-panel-content__wrap,.v-expansion-panels[data-v-a5ca73ec] .v-expansion-panel-header{line-height:1.3em}.v-window[data-v-a5ca73ec] iframe,.v-window[data-v-a5ca73ec] img{max-width:100%!important}.v-window[data-v-a5ca73ec] ol,.v-window[data-v-a5ca73ec] ul{padding:0 24px 0 16px!important}", ""]);
// Exports
module.exports = exports;
